// extracted by mini-css-extract-plugin
export default {"image":"User_image__VkzDQ"};